// extracted by mini-css-extract-plugin
export default {"base":"styles_base__sdRmc"};